import { Logger } from "@amzn/dolphin-web-framework";

/**
 * Constants for application data storage keys
 * @enum {string}
 */
export const APP_DATA_KEYS = {
    IS_AUTOMATION_TC_AVAILABLE: "IS_AUTOMATION_TC_AVAILABLE",
};

/**
 * Class handling application data persistence using sessionStorage
 * Provides methods for saving and retrieving data with JSON serialization
 */
class AppData {
    /**
     * Saves a value to sessionStorage with JSON serialization
     * @param {string} key - The storage key
     * @param {*} value - The value to store. If null/undefined, removes the key
     */
    save(key, value) {
        if (value === null || value === undefined) {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
    }

    /**
     * Retrieves and parses a value from sessionStorage
     * @param {string} key - The storage key
     * @returns {*} Parsed value or null if parsing fails
     */
    get(key) {
        const value = sessionStorage.getItem(key);
        try {
            return JSON.parse(value);
        } catch (e) {
            Logger.log.error(`[AppData] Failed to parse sessionStorage item for key "${key}" with value: ${value}`, e);
            return null;
        }
    }

    /**
     * Sets the automation thin client availability status
     * @param {boolean} isAutomationTCAvailable - Availability status
     */
    setIsAutomationTCAvailable(isAutomationTCAvailable) {
        this.save(APP_DATA_KEYS.IS_AUTOMATION_TC_AVAILABLE, isAutomationTCAvailable);
    }

    /**
     * Gets the automation thin client availability status
     * @returns {boolean|null} Availability status or null if not set
     */
    isAutomationTCAvailable() {
        return this.get(APP_DATA_KEYS.IS_AUTOMATION_TC_AVAILABLE);
    }
}

const AppDataStore = new AppData();

export default AppDataStore;
